import { get, set } from 'lodash';
import { BICValidation, IBANValidation } from 'src/lib/validation/ValidationTypes';
import { addIndexToPath } from 'src/utils/helper';
import Schema from 'validate';

// import schemas
import OrganisationSchema from 'src/lib/paths/organisation_FULL_Paths.json';
let P = OrganisationSchema.attributes;

function BankDatenValidator(formValues: any) {
	const schema = createSchema(formValues);
	const DynamicBankDatenValidator = new Schema(schema, { strip: false });
	DynamicBankDatenValidator.message({
		required: (_path: string) => 'Pflichtfeld.',
		type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Fehler. Geben Sie als Grund "falscher Datentyp, ${path}" an.`,
	});
	return DynamicBankDatenValidator;
}

function createSchema(formValues: any) {
	let definition = {};
	const bankverbindungLength = get(formValues, P.Bankdaten.path, []).length;

	for (let index = 0; index < bankverbindungLength; index++) {
		const bezeichnungPath = addIndexToPath(P.Bankdaten.schema.attributes.Bezeichnung.path, index, P.Bankdaten.path);
		const ibanPath = addIndexToPath(P.Bankdaten.schema.attributes.Bankdaten_IBAN.path, index, P.Bankdaten.path);
		const bicPath = addIndexToPath(P.Bankdaten.schema.attributes.Bankdaten_BIC.path, index, P.Bankdaten.path);
		const namePath = addIndexToPath(P.Bankdaten.schema.attributes.Bankdaten_Kontoinhaber.path, index, P.Bankdaten.path);
		const institutPath = addIndexToPath(P.Bankdaten.schema.attributes.Bankdaten_Geldininstitut.path, index, P.Bankdaten.path);

		const iban = get(formValues, ibanPath, '');
		const hasDEIban = typeof iban === 'string' && iban.includes('DE');
		if (!hasDEIban) set(definition, bicPath, { required: true, ...BICValidation });
		set(definition, bezeichnungPath, { type: String, required: true });
		set(definition, ibanPath, { required: true, ...IBANValidation });
		set(definition, namePath, { type: String, required: true });
		set(definition, institutPath, { type: String, required: true });
	}
	return definition;
}

export default BankDatenValidator;
